module.exports = __webpack_public_path__ + "static/media/0019.498c35dd.jpg";